import ErrorPage from '@/common/components/ErrorPage'
import notBlocked from '@/common/middleware/notBlocked'
import SuccessPage from '@/common/components/SuccessPage'
import Widget from '@/dynamic_modules/sign_widget/views/Widget'
import SignWidgetButtons from '@/dynamic_modules/sign_widget/components/SignWidgetButtons'
import WidgetLayout from '@/dynamic_modules/sign_widget/layouts/WidgetLayout'
import SignWidget from '@/dynamic_modules/sign_widget/components/sign-widget/SignWidget'
import WidgetButtonsEnum from '@/dynamic_modules/sign_widget/enums/WidgetButtonsEnum'
import widgetAuth from '@/dynamic_modules/sign_widget/middleware/widgetAuth'

export default [
  {
    path: '/sign',
    name: 'Widget',
    component: Widget,
    children: [
      {
        path: 'error',
        name: 'ErrorWidget',
        components: {
          content: ErrorPage,
          buttons: SignWidgetButtons
        },
        meta: {
          layout: WidgetLayout
        }
      },
      {
        path: 'success',
        name: 'SuccessWidget',
        components: {
          content: SuccessPage,
          buttons: SignWidgetButtons
        },
        props: {
          content: () => ({ message: 'Заявка подписана' })
        },
        meta: {
          layout: WidgetLayout
        }
      },
      {
        path: 'widget',
        name: 'SignWidget',
        components: {
          content: SignWidget,
          buttons: SignWidgetButtons
        },
        props: {
          content: () => ({ successRoute: '/sign/success', unsuccessRoute: '/sign/error?cause=wrongToken' }),
          buttons: () => ({ buttons: [WidgetButtonsEnum.signAndSend] })
        },
        meta: {
          middleware: [
            widgetAuth,
            notBlocked
          ],
          widget: {
            failureRedirect: '/sign/error?cause=wrongToken'
          },
          layout: WidgetLayout
        }
      }
    ]
  }
]
